import React, { FC, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import MinerGameWrapper from '@pages/_Games/Miner/MinerGameWrapper';
import CapybaraGame from '@pages/_Games/Capybara';
import FlappyGame from '@pages/_Games/Flappy';
import ImageEditorTestPage from '@pages/_Games/ImageEditorTest';
import PageLoadTest from '@shared/components/PageLoadTest';
import ClientPageMaze from 'src/pages/Constructors/ClientMaze';
import ClientPageMazeFree from 'src/pages/Constructors/ClientMazeFree';
import ClientPageMemory from 'src/pages/Constructors/ClientMemory';
import ClientPageMiner from 'src/pages/Constructors/ClientMiner/index2';
import ClientPageSlot from 'src/pages/Constructors/ClientSlot';
import ClientPageCapybara from 'src/pages/Constructors/ClientCapybara';
import ClientPageFlappy from 'src/pages/Constructors/ClientFlappy';
import GamePage from '@pages/Game';
import LoginPage from '@pages/Login';
import MasterPage from '@pages/Master';
import PartnerDashboard from '@pages/Partner/Dashboard';
import PartnerLoginForm from '@pages/Partner/LoginForm';

import { Layout } from '@shared/components';

import { authContext } from '@store/index';

import ConditionalRoute from './ConditionalRoute';

const Router: FC = () => {
  const [authData] = useContext(authContext);

  const getDashboardComponent = () => {
    console.log('🔍 getDashboardComponent:', { authData });
    if (!authData) {
      return null;
    }

    if (authData.masterKey) {
      return <MasterPage masterKey={authData.masterKey} />;
    }

    if (authData.gameKey) {
      if (authData.gameKey.gameType === 'Slot') {
        return <ClientPageSlot gameKey={authData.gameKey} />;
      }
      if (authData.gameKey.gameType === 'maze') {
        return <ClientPageMaze gameKey={authData.gameKey} />;
      }
      if (authData.gameKey.gameType === 'mazeFree') {
        return <ClientPageMazeFree gameKey={authData.gameKey} />;
      }
      if (authData.gameKey.gameType === 'miner') {
        return <ClientPageMiner gameKey={authData.gameKey} />;
      }
      if (authData.gameKey.gameType === 'capybara') {
        return <ClientPageCapybara gameKey={authData.gameKey} />;
      }
      if (authData.gameKey.gameType === 'flappy') {
        return <ClientPageFlappy gameKey={authData.gameKey} />;
      }
      return <ClientPageMemory gameKey={authData.gameKey} />;
    }
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginPage />}
      />
      <Route path="/game" element={<GamePage />} />
      <Route path="/miner" element={<MinerGameWrapper gameKey={null} gameSettings={null} />} />
      <Route path="/game/miner" element={<MinerGameWrapper gameKey={null} gameSettings={null} />} />
      <Route path="/game/capybara" element={<CapybaraGame gameKey={null} gameSettings={null} />} />
      <Route path="/game/flappy" element={<FlappyGame gameKey={null} gameSettings={null} />} />
      <Route path="/test/image-editor" element={<ImageEditorTestPage />} />
      <Route path="/test/page-load" element={<PageLoadTest />} />
      
      {/* Партнёрские роуты */}
      <Route path="/partners/login" element={<PartnerLoginForm />} />
      <Route path="/partners/dashboard" element={<PartnerDashboard />} />
      
      <Route element={<Layout />}>
        <Route
          path="/"
          element={
            <ConditionalRoute condition={!!authData} redirectTo="/login">
              {getDashboardComponent()}
            </ConditionalRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default Router;
